import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

class DashboardHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadPossibleCyclesForUserCalled: false,
      openChangeCyclePopup: false,
      cycleSelected: this.props?.user?.cycleSelected
        ? this.props?.user?.cycleSelected
        : null,
      cycleSelectorIsOpen: false,
      popupSelectOptions: [],
      submitedExam: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timer !== this.props.timer) {
      if (this.props.timer <= 0 && !this.state.submitedExam) {
        this.props.submitPracticeExam(
          this.props.practiceExam,
          this.props.resultsSummarized,
          this.props.practiceExam.isCustom,
        );
        this.setState({ submitedExam: true });
      }
    }
  }

  componentWillUnmount() {
    this.setState({
      loadPossibleCyclesForUserCalled: false,
      openChangeCyclePopup: false,
      cycleSelected: null,
      cycleSelectorIsOpen: false,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.user.id &&
      this.props.possibleCyclesForUser.length === 0 &&
      !this.state.loadPossibleCyclesForUserCalled
    ) {
      this.props.loadPossibleCyclesForUser(nextProps.user);
      this.setState({
        loadPossibleCyclesForUserCalled: true,
      });
    }
    if (!this.state.submitedExam && this.state.submitPracticeExamSuccess) {
      this.props.getWeeklyPracticeExams();
      this.setState({ submitedExam: false });
    }

    if (
      nextProps.user.cycleSelected !== this.props.user.cycleSelected &&
      nextProps.user.cycleSelected &&
      this.props.user.cycleSelected
    ) {
      this.props.resetPracticeExamHistory();
    }

    if (
      nextProps.possibleCyclesForUser.length !== 0 &&
      !this.state.loadPossibleCyclesForUserCalled &&
      !nextProps.dashboardHeaderInfoWaiting
    ) {
      this.setState({
        loadPossibleCyclesForUserCalled: true,
        openChangeCyclePopup: false,
      });
    }

    if (
      nextProps.user &&
      nextProps.possibleCyclesForUser.length !== 0 &&
      this.state.cycleSelected === null
    ) {
      this.setState({
        cycleSelected: this.getUserCycle(
          nextProps.possibleCyclesForUser,
          nextProps.user,
        ),
      });
    }
  }

  getDisplayName = (user) => {
    if (user && user.id) {
      if (user.username && user.username !== '') {
        return user.username;
      }
      return `${user.name ? user.name : ''} ${
        user.lastName ? user.lastName : ''
      }`;
    }
    return '';
  };

  getDisplayNameWithoutLastName = (user) => {
    if (user && user.id) {
      if (user.username && user.username !== '') {
        return user.username;
      }
      return `${user.name ? user.name : ''}`;
    }
    return '';
  };

  getUserExamDate = (possibleCyclesForUser, user) => {
    let selectedCycle = null;

    if (possibleCyclesForUser && possibleCyclesForUser.length > 0) {
      selectedCycle = possibleCyclesForUser.find(
        (cycle) => cycle.id === user.cycleSelected,
      );
    }
    return selectedCycle ? selectedCycle.title : '';
  };

  getRatingExamText = () => {
    const { user, possibleCyclesForUser, userSubscription } = this.props;
    if (userSubscription && userSubscription.warfarePlan)
      return 'Warfare and Qualifications';
    if (
      user &&
      userSubscription &&
      user.id &&
      possibleCyclesForUser.length > 0
    ) {
      const ratingExam = user.ratingExam ? user.ratingExam : user.rank;
      const userInfo = `${ratingExam} Exam - `;
      const examDate = this.getUserExamDate(possibleCyclesForUser, user);
      return userInfo + examDate;
    }
    return '';
  };

  getUserCycle = (possibleCyclesForUser, user) => {
    let cycle = null;
    if (user.cycleSelected) {
      cycle = possibleCyclesForUser.find(
        (c) => Number(c.id) === Number(user.cycleSelected),
      );
    }
    if (!cycle) {
      cycle = possibleCyclesForUser.find((c) => c.isActive === true);
    }

    return cycle.id;
  };

  handleCycleSelectorClick = () => {
    this.setState({
      cycleSelectorIsOpen: !this.state.cycleSelectorIsOpen,
    });
  };

  handleTogglePopup = () => {
    this.setState({
      openChangeCyclePopup: !this.state.openChangeCyclePopup,
    });
  };

  handleSelectCycle = (cycleId) => {
    this.setState({
      cycleSelected: cycleId,
    });
  };

  setUserCycle = () => {
    this.props.setUserCycle(this.state.cycleSelected);
    this.setState({ loadPossibleCyclesForUserCalled: false });
  };

  renderCycleSelector = () => {
    const { possibleCyclesForUser } = this.props;
    let cycleTitle = possibleCyclesForUser.find(
      (cycle) => cycle.id === this.state.cycleSelected,
    );
    cycleTitle = cycleTitle ? cycleTitle.title : '';
    return (
      <div className="field mb-0">
        <Dropdown
          isOpen={this.state.cycleSelectorIsOpen}
          toggle={this.handleCycleSelectorClick}
          className="rating-exam-selector"
        >
          <DropdownToggle className="rating-exam-dropdown-toggle">
            <span className="option-title">{cycleTitle}</span>
            {this.state.cycleSelectorIsOpen ? (
              <i className="icon-expand select-icon rotate down" />
            ) : (
              <i className="icon-expand select-icon rotate" />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {this.props.possibleCyclesForUser.map((cycle) => (
              <DropdownItem
                className="drop-item"
                onClick={() => this.handleSelectCycle(cycle.id)}
                key={cycle.id}
              >
                {cycle.title}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
        <div className="gray-divider" />
      </div>
    );
  };

  renderChangeCyclePopup = () => (
    <Modal
      isOpen={this.state.openChangeCyclePopup}
      className="rating-exam-popup modal-dialog-centered change-cycle-popup"
      modalClassName="rating-exam-modal"
      toggle={this.handleTogglePopup}
    >
      <ModalHeader className="rating-exam-modal-header">
        <i className="icon-close" onClick={this.handleTogglePopup} />
        <div className="title">Change Cycle</div>
      </ModalHeader>
      <div className="gradient-divider" />
      <ModalBody className="rating-exam-modal-body ">
        <p className="warning-message">
          Which exam cycle do you want to study for?
        </p>
        {this.renderCycleSelector()}
        <button
          className="btn btn-call-to-action text-center mt-5 mb-3 w-70"
          disabled={
            !this.state.cycleSelected || this.props.dashboardHeaderInfoWaiting
          }
          onClick={this.setUserCycle}
        >
          Submit
        </button>
      </ModalBody>
    </Modal>
  );

  render() {
    return (
      <>
        {this.renderChangeCyclePopup()}
        <div className="dashboard-header-container">
          <h1 className="d-none d-lg-block">
            Welcome, {this.getDisplayNameWithoutLastName(this.props.user)}!
          </h1>
          <div className="information-section">
            <div className="avatar-container d-flex">
              {this.props.avatar !== '' && this.props.avatar !== null ? (
                <img
                  alt="..."
                  src={this.props.avatar}
                  className="m-auto avatar-image"
                  height="118"
                  width="118"
                />
              ) : (
                <i className="icon-profile avatar m-auto" />
              )}
            </div>
            <div className="user-information">
              <div className="information-left">
                <h4>{this.getDisplayName(this.props.user)}</h4>
                {this.props.rateName && (
                  <p className="information">{this.props.rateName}</p>
                )}
              </div>
              <div className="divider-line-container h-100">
                <div className="vertical-line h-100" />
              </div>
              <div className="information-right">
                <p className="header-label">STUDYING FOR</p>
                <div className="plan-information">
                  <p className="information large">
                    {this.getRatingExamText()}
                  </p>
                  {this.props.userSubscription &&
                    !this.props.userSubscription.warfarePlan && (
                      <div className="d-ms-flex d-lg-block d-xl-flex px-xl-3">
                        <div className="py-1 m-auto px-1 d-flex">
                          <Link
                            to="account-settings"
                            className="change-button btn btn-outline-download rounded-lg bg-transparent mx-lg-auto ml-xl-2"
                          >
                            CHANGE
                          </Link>
                        </div>

                        {/* 
                        TODO: This code is commented out because it is expected to be changed from the account settings.

                        <div className="py-1 m-auto px-1">
                          <button
                            onClick={this.handleTogglePopup}
                            className="change-button btn btn-outline-download rounded-lg bg-transparent"
                          >
                            CHANGE CYCLE
                          </button>
                        </div> */}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>

          {!this.props.dashboardHeaderInfoWaiting &&
            this.props.dashboardHeaderInfo && (
              <div className="earned-points-section">
                {this.props.dashboardHeaderInfo.userPoints !== null &&
                  this.props.dashboardHeaderInfo.userPoints !== undefined && (
                    <div className="section-icon container">
                      <div className="circle-icon">
                        <i className="icon-star" />
                      </div>
                      <div className="information-icon">
                        <p className="information large">
                          {Number(this.props.dashboardHeaderInfo.userPoints)}
                        </p>
                        <p className="header-label">POINTS</p>
                      </div>
                    </div>
                  )}
                {/* {this.props.dashboardHeaderInfo.userLevel !== null &&
                this.props.dashboardHeaderInfo.userLevel !== undefined && (
                  <div className="section-icon container">
                    <div className="circle-icon">
                      <i className="icon-bars" />
                    </div>
                    <div className="information-icon">
                      <p className="information large">
                        {Number(this.props.dashboardHeaderInfo.userLevel)}
                      </p>
                      <p className="header-label">LEVEL</p>
                    </div>
                  </div>
                )}
              {this.props.dashboardHeaderInfo.userBadges !== null &&
                this.props.dashboardHeaderInfo.userBadges !== undefined && (
                  <div className="section-icon container">
                    <div className="circle-icon">
                      <i className="icon-trophy" />
                    </div>
                    <div className="information-icon">
                      <p className="information large">
                        {Number(this.props.dashboardHeaderInfo.userBadges)}
                      </p>
                      <p className="header-label">BADGES</p>
                    </div>
                  </div>
                )} */}
              </div>
            )}
          {this.props.dashboardHeaderInfoWaiting && (
            <div className="earned-points-section">
              <div className="empty-section">
                <CircularLoading className="loading-header-info-gif" />
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}
DashboardHeader.propTypes = {
  point: PropTypes.number,
  level: PropTypes.number,
  badges: PropTypes.number,
  cycle: PropTypes.string,
  pfeRate: PropTypes.string,
  userName: PropTypes.string,
  userLastName: PropTypes.string,
  avatar: PropTypes.string,
};

export default DashboardHeader;
